export default "__VITE_ASSET__CpaAF3pD__"